import environment from '../../config/environment';

// API Configuration
export const API_CONFIG = {
  // Your ngrok base URL (can be overridden by environment)
  BASE_URL: environment.API_BASE_URL,
  
  // API endpoints
  ENDPOINTS: {
    // Authentication
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    LOGOUT: '/api/auth/logout',
    
    // Step-wise Bookings
    BOOKING_STEP1: '/api/bookings/step1',
    BOOKING_STEP2: (id) => `/api/bookings/step2/${id}`,
    BOOKING_STEP3: (id) => `/api/bookings/step3/${id}`,
    BOOKING_STEP4: (id) => `/api/bookings/step4/${id}`,
    
    // General Bookings
    GET_ALL_BOOKINGS: '/api/bookings',
    GET_BOOKING_BY_ID: (id) => `/api/bookings/${id}`,
    GET_BOOKINGS_BY_MOBILE: '/api/bookings/mobile',
    UPDATE_BOOKING_STATUS: (id) => `/api/bookings/${id}/status`,
    
    // Price List
    PRICE_LIST: '/api/price-list',
    PRICE_ITEM: (id) => `/api/price-list/${id}`,

    // Scrap Rates
    SCRAP_RATES: '/api/scrap',
    
    // User Profile
    USER_PROFILE: '/api/user/profile',
    UPDATE_PROFILE: '/api/user/profile',
    
    // Contact Us
    CONTACT_US: '/api/ContactUs',
    
    // Admin
    ADMIN_STATS: '/api/admin/stats',
    ADMIN_BOOKINGS: '/api/admin/bookings',
    ADMIN_LOGIN: '/api/admin/login',
  },
  
  // Request timeout
  TIMEOUT: environment.API_TIMEOUT,
  
  // Default headers
 DEFAULT_HEADERS: {
  Accept: 'application/json'
}


};

// Helper function to get full URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get headers with auth token
export const getAuthHeaders = (token) => {
  return {
    ...API_CONFIG.DEFAULT_HEADERS,
    'Authorization': `Bearer ${token}`,
  };
};
